
export enum RequestStatus{

    None,
    New,
    Scheduled,
    Error,
    Done,
    UnProcessable
}


// WEBPACK FOOTER //
// D:/a/1/s/src/app/Reports/model/RequestStatus.ts